module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-tree-container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tree-background block"
  }, [_c('el-tree', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.categoryList,
      "default-expand-all": "",
      "expand-on-click-node": false
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var node = ref.node;
        var data = ref.data;

        return _c('ul', {
          staticClass: "custom-tree-node"
        }, [_c('li', {
          staticStyle: {
            "width": "80px"
          }
        }, [_c('span', [_vm._v(_vm._s(data.cat_id))])]), _vm._v(" "), _c('li', [_c('span', [_vm._v(_vm._s(data.cat_name))])]), _vm._v(" "), _c('li', {
          staticStyle: {
            "width": "80px"
          }
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (data.p_order),
            expression: "data.p_order"
          }],
          staticStyle: {
            "width": "80px"
          },
          attrs: {
            "placeholder": "分类排序"
          },
          domProps: {
            "value": (data.p_order)
          },
          on: {
            "change": function($event) {
              return _vm.editPOrder(node, data)
            },
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.$set(data, "p_order", $event.target.value)
            }
          }
        })]), _vm._v(" "), _c('li', {
          staticClass: "category-icon"
        }, [_c('span', {
          on: {
            "click": function($event) {
              return _vm.handleImgChange(data)
            }
          }
        }, [(data.pic_url) ? _c('img', {
          attrs: {
            "src": _vm.wximageurl + data.pic_url
          }
        }) : _c('i', {
          staticClass: "iconfont icon-image"
        })])]), _vm._v(" "), _c('li', [_c('el-switch', {
          attrs: {
            "active-value": "true",
            "inactive-value": "false",
            "active-color": "#13ce66",
            "inactive-color": "#dadadd"
          },
          on: {
            "change": function($event) {
              return _vm.switchAuth(node, data)
            }
          },
          model: {
            value: (data.disabled),
            callback: function($$v) {
              _vm.$set(data, "disabled", $$v)
            },
            expression: "data.disabled"
          }
        })], 1)])
      }
    }])
  })], 1), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.imgDialog,
      "sc-status": _vm.isGetImage
    },
    on: {
      "chooseImg": _vm.pickImg,
      "closeImgDialog": _vm.closeImgDialog
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block"
  }, [_c('ul', {
    staticClass: "custom-tree-node-title"
  }, [_c('li', {
    staticStyle: {
      "width": "80px"
    }
  }, [_vm._v("分类ID")]), _vm._v(" "), _c('li', [_vm._v("分类名称")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "width": "80px"
    }
  }, [_vm._v("分类排序")]), _vm._v(" "), _c('li', [_vm._v("图片")]), _vm._v(" "), _c('li', [_vm._v("是否屏蔽")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-39d28b1c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39d28b1c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/sharer/sku/sku_cate.vue
// module id = 2625
// module chunks = 0